export default "__VITE_ASSET__a7ce0af1__"